import {FC} from "react";
import {Card} from "react-bootstrap";
import Loader from '@/components/common/loader/loader';
import useTopPerformingNetwork from "@oldDashboard/legacyHooks/useTopPerformingNetwork";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { getFiltersDate } from "@oldDashboard/legacyUtils";


interface TopPerformingNetworkProps { data: any, timePeriods: TimePeriods[], affiliateId: any, launchSelected: String, timePeriodSelected: string, searching: boolean}
const TopPerformingNetworkTile: FC<TopPerformingNetworkProps> = (props) => {
    const { data,timePeriods,  affiliateId, launchSelected, timePeriodSelected, searching } = props;
    const { startDate, endDate } = getFiltersDate(timePeriods,timePeriodSelected);
    const { isLoading } = useTopPerformingNetwork(affiliateId, launchSelected, timePeriodSelected, startDate, endDate, searching);
    if(data == null) return null;
    return (
        <Card className="custom-card overflow-hidden " style={{height: '250px'}}>
            { isLoading && <Loader/> }
            <Card.Body>
                <div className="row h-100">
                    <div className="col-12">
                        <div className="d-flex justify-content-center align-items-center justify-contetn-center flex-column h-100">
                            <h4 className="fw-semibold mb-2 text-center">Top Performing Network</h4>
                            <div className="ms-2 d-flex justify-content-center flex-column">
                                { data.network === "meta" ? 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#845adf" className="bi bi-meta" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M8.217 5.243C9.145 3.988 10.171 3 11.483 3 13.96 3 16 6.153 16.001 9.907c0 2.29-.986 3.725-2.757 3.725-1.543 0-2.395-.866-3.924-3.424l-.667-1.123-.118-.197a55 55 0 0 0-.53-.877l-1.178 2.08c-1.673 2.925-2.615 3.541-3.923 3.541C1.086 13.632 0 12.217 0 9.973 0 6.388 1.995 3 4.598 3q.477-.001.924.122c.31.086.611.22.913.407.577.359 1.154.915 1.782 1.714m1.516 2.224q-.378-.614-.727-1.133L9 6.326c.845-1.305 1.543-1.954 2.372-1.954 1.723 0 3.102 2.537 3.102 5.653 0 1.188-.39 1.877-1.195 1.877-.773 0-1.142-.51-2.61-2.87zM4.846 4.756c.725.1 1.385.634 2.34 2.001A212 212 0 0 0 5.551 9.3c-1.357 2.126-1.826 2.603-2.581 2.603-.777 0-1.24-.682-1.24-1.9 0-2.602 1.298-5.264 2.846-5.264q.136 0 .27.018Z"/>
                                    </svg> :  
                                    <i className={`text-primary mx-auto bi bi-${data.network}`} style={{fontSize: "3.1rem"}}></i>
                                }
                                <p className="text-center text-capitalize fs-15">{data.network}</p>
                            </div>
                            <p className="mb-4 fs-18 op-7 d-flex justify-content-center ">
                               <b> {Number(data.percent_engagements).toFixed(2)}%</b> &nbsp;of Engagements
                            </p>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default TopPerformingNetworkTile;
